export default __webpack_public_path__ + "media/images/dashboard_icons/question-mark-83d469c91a354c23630c5c3c4f77b6c4.svg";